<script>
/**
 * Earning Reports component
 */
export default {
  props: ['data'],
  data() {
    return {
      tracking_info : this.data,
      WeeklyEarning: {
        series: [0],
        chartOptions: {
          chart: {
            type: "radialBar",
            wight: 60,
            height: 60,
            sparkline: {
              enabled: true
            }
          },
          colors: ["#5664d2"],
          stroke: {
            lineCap: "round"
          },
          plotOptions: {
            radialBar: {
              hollow: {
                margin: 0,
                size: "70%"
              },
              track: {
                margin: 0
              },
              dataLabels: {
                show: false
              }
            }
          }
        }
      },
      monthlyEarning: {
        series: [65],
        chartOptions: {
          chart: {
            type: "radialBar",
            wight: 60,
            height: 60,
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          colors: ["#1cbb8c"],
          stroke: {
            lineCap: "round"
          },
          plotOptions: {
            radialBar: {
              hollow: {
                margin: 0,
                size: "70%"
              },
              track: {
                margin: 0
              },

              dataLabels: {
                show: false
              }
            }
          }
        }
      }
    };
  },
  mounted() {
    console.log(this.data)
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <b-dropdown right toggle-class="arrow-none card-drop" class="float-right" variant="white">
        <template v-slot:button-content>
          <i class="mdi mdi-dots-vertical"></i>
        </template>
        <!-- item-->
<!--        <b-dropdown-item>Sales Report</b-dropdown-item>-->
        <!-- item-->
        <b-dropdown-item>Export Report</b-dropdown-item>
<!--        &lt;!&ndash; item&ndash;&gt;-->
<!--        <b-dropdown-item>Profit</b-dropdown-item>-->
<!--        &lt;!&ndash; item&ndash;&gt;-->
<!--        <b-dropdown-item>Action</b-dropdown-item>-->
      </b-dropdown>

      <h4 class="card-title mb-4">Tracking Reports</h4>
      <div class="text-center">
        <div class="row">
          <div class="col-sm-6">
            <div>
              <div class="mb-3">
                <apexchart
                  class="apex-charts"
                  height="60"
                  wight="60"
                  dir="ltr"
                  :series="[Math.round(tracking_info.shipment_percentage)]"
                  :options="WeeklyEarning.chartOptions"
                ></apexchart>
              </div>
              <p class="text-muted text-truncate mb-2">Tracker Shipment</p>
              <h5 class="mb-0">{{tracking_info.shipment}}</h5>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="mt-5 mt-sm-0">
              <div class="mb-3">
                <apexchart
                  class="apex-charts"
                  height="60"
                  wight="60"
                  dir="ltr"
                  :series="[Math.round(tracking_info.return_percentage)]"
                  :options="monthlyEarning.chartOptions"
                ></apexchart>
              </div>

              <p class="text-muted text-truncate mb-2">Tracker Return Result</p>
              <h5 class="mb-0">{{tracking_info.return}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>